import React, { Component } from 'react';
import * as $ from 'jquery';
import Publicaciones from './Publicaciones.js';
import axios from 'axios';
import { MENU } from '../Sidebar.js';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import '../../marketplace.css';

let cancelToken;
let state;
let tokenSession;
let cssModal
class MarketplaceContainer extends Component {

  getInitState = () => {
    return {
      publicaciones: null,
      publicaciones_ultimo_id: null,
      ver_mas: false,
      texto: '',
      shared: false,
      // cssModal: {},
      publicacion_imagen: null,
      contiene_imagen: 0,
      imagen_preview: null,
    };
  }

  constructor(props) {
    super(props);
    if (tokenSession !== props.getTokenSession()) {
      state = this.getInitState();
    }
    this.state = state;
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
  }

  componentDidMount() {
    this.reload();
  }

  componentWillUnmount() {
    cancelToken.cancel('Component will unmount.');
    state = this.state;
    tokenSession = this.props.getTokenSession();
  }

  reload = () => {

  }

  reload = () => {

    this.getProfile({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession(),
    });
  }

  getProfile = (params) => {
    this.props.post(
      "/getProfileUser",
      params,
      (response) => this.didGetProfile(response),
      (error) => this.handleErrorResponse(error),
      cancelToken
    );
  }

  didGetProfile = (response) => {
    this.getPublicaciones({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession(),
      publicaciones_ultimo_id: this.state.publicaciones_ultimo_id,
      user_id: response.user_id
    });
  }

  hadleClick = () => {
    this.setState({ shared: false });
  }

  getPublicaciones = (params) => {
    this.props.post(
      "/getPublicacionesById",
      params,
      (response) => this.didGetPublicaciones(response, params.publicaciones_ultimo_id),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  didGetPublicaciones(response, ultimo_id) {
    if (ultimo_id) {
      this.setState({
        publicaciones: [...this.state.publicaciones, ...response.publicaciones],
        publicaciones_ultimo_id: response.publicaciones_ultimo_id,
        ver_mas: response.ver_mas,
      });
    } else {
      this.setState({
        publicaciones: response.publicaciones,
        publicaciones_ultimo_id: response.publicaciones_ultimo_id,
        ver_mas: response.ver_mas,
      });
    }
  }

  handleVerMas = () => {
    this.getPublicaciones({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession(),
      publicaciones_ultimo_id: this.state.publicaciones_ultimo_id
    });
  }

  handleTextChange = (e) => {
    this.setState({ texto: e.target.value })
    if (e.target.value) {
      this.setState({ shared: true })
    } else {
      this.setState({ shared: false })
    }
  }

  handleImageChange = (event) => {
    this.setState({
      publicacion_imagen: event.target.files[0],
      contiene_imagen: 1,
      imagen_preview: URL.createObjectURL(event.target.files[0])
    })
  }

  handleAddPublicacion = () => {
    const params = new FormData();
    params.append("token_id", this.props.getTokenId());
    params.append("token_session", this.props.getTokenSession());
    params.append("texto", this.state.texto);
    params.append("contiene_imagen", this.state.contiene_imagen);
    params.append("publicacion_imagen", this.state.publicacion_imagen);

    this.addPublicacion(params);
  }

  addPublicacion = (params) => {
    this.props.post(
      "/addPublicacion",
      params,
      (response) => this.didAddPublicacion(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  didAddPublicacion(response) {
    this.setState({
      publicaciones: [response.publicacion, ...this.state.publicaciones],
      texto: '',
      publicacion_imagen: null,
      contiene_imagen: 0,
      imagen_preview: null,
      shared: false
    });
    $('#modalMarketplace').removeClass("in");
    cssModal = { display: "none" }
  }


  handleAddLike = (publicacion_id) => {
    this.addPublicacionLike({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession(),
      publicacion_id: publicacion_id
    });
  }

  addPublicacionLike = (params) => {
    this.props.post(
      "/addPublicacionLike",
      params,
      (response) => this.didAddLike(response, params.publicacion_id),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  didAddLike(response, publicacion_id) {

    let publicacion_index = this.state.publicaciones.findIndex(publicacion => publicacion.id === publicacion_id);
    let actualizar_publicaciones = this.state.publicaciones;
    actualizar_publicaciones[publicacion_index].usuario_like = response.like_id;
    actualizar_publicaciones[publicacion_index].likes = response.likes;

    this.setState({
      publicaciones: actualizar_publicaciones
    });
  }

  handleRemoveLike = (publicacion_id, like_id) => {
    this.removePublicacionLike({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession(),
      publicacion_id: publicacion_id,
      like_id: like_id
    });
  }

  removePublicacionLike = (params) => {
    this.props.post(
      "/removePublicacionLike",
      params,
      (response) => this.didRemoveLike(response, params.publicacion_id),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  didRemoveLike(response, publicacion_id) {

    let publicacion_index = this.state.publicaciones.findIndex(publicacion => publicacion.id === publicacion_id);
    let actualizar_publicaciones = this.state.publicaciones;
    actualizar_publicaciones[publicacion_index].usuario_like = null;
    actualizar_publicaciones[publicacion_index].likes = response.likes;

    this.setState({
      publicaciones: actualizar_publicaciones
    });
  }


  handleAddComentario = (publicacion_id, texto) => {
    this.addPublicacionComentario({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession(),
      publicacion_id: publicacion_id,
      texto: texto
    });
  }

  addPublicacionComentario = (params) => {
    this.props.post(
      "/addPublicacionComentario",
      params,
      (response) => this.didAddComentario(response, params.publicacion_id),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  didAddComentario(response, publicacion_id) {

    let publicacion_index = this.state.publicaciones.findIndex(publicacion => publicacion.id === publicacion_id);
    let actualizar_publicaciones = this.state.publicaciones;
    actualizar_publicaciones[publicacion_index].comentarios = response.comentarios;
    actualizar_publicaciones[publicacion_index].comentarios_contenido = response.comentarios_contenido;

    this.setState({
      publicaciones: actualizar_publicaciones
    });
  }


  renderAgregarPublicacion = () => {
    // {(this.state.shared) ? $('#actionShared').click() : ''}
    return (
      <div className="panel-marjetplace ">
        <div className="panel panel-default sectionShareComent">
          <input
            className="hidden"
            id="chooserImage"
            onChange={this.handleImageChange}
            type="file"
          />
          <div className="panel-body">
            <h4 className="panel-title">
              <div className="row">
                <img className="usuario_imagen imagen_agregar" alt="Imagen de usuario" src={this.props.user.picture}></img>
                <input id="actionShared" className="textShared" placeholder="Comparte algo con la comunidad" type="text" readOnly data-target="#modalMarketplace" data-toggle="modal" />
              </div>
              {/* <textarea value={this.state.texto} onChange={this.handleTextChange} className="round_textarea" style={{width: '90%'}} id="texto_agregar_publicacion" placeholder="Comparte algo con la comunidad" required="" rows="2"></textarea> */}
            </h4>
            {/* <span style={{float:'right'}}>
                  <button onClick={() => this.handleAddPublicacion()} className="btn btn-info btn-sm">Publicar</button>
                </span>
                <span style={{float:'right'}}>&nbsp;&nbsp;</span>
                <span style={{float:'right'}}>
                  <a onClick={() => $('#chooserImage').click()}>
                    <i className="fa-pull-right fa-border fa fa-lg fa-paperclip round_icon" />
                  </a>
                </span> */}
            {/* {
                  this.state.imagen_preview && 
                  <div className="panel-body">
                    <br></br>
                    <img className="imagen_publicacion" alt="Imagen" src={this.state.imagen_preview}></img>
                  </div>
                } */}
          </div>
        </div>
        <div className="modal fade" id="modalMarketplace" role="dialog" style={cssModal}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header" style={{ background: '#33cccc' }}>
                <div className="navbar-header col-md-12">
                  <center>
                    <h4 style={{ color: 'white' }}>Crear publicación</h4>
                  </center>
                </div>
              </div>
              <div className="modal-body">
                <center>
                  <textarea value={this.state.texto} onChange={this.handleTextChange} className="round_textarea" style={{ width: '90%' }} id="texto_agregar_publicacion" placeholder="Comparte algo con la comunidad" required rows="2"></textarea>
                  {
                    this.state.imagen_preview &&
                    <div className="panel-body">
                      <br></br>
                      <img className="imagen_publicacion" alt="Imagen" src={this.state.imagen_preview}></img>
                    </div>
                  }
                </center>
              </div>
              <div className="modal-footer">
                <table style={{ float: 'right' }}>
                  <tbody>
                    <tr>
                      <td style={{ paddingRight: '10px' }}>
                        <a onClick={() => $('#chooserImage').click()}><i className="fa-pull-right fa-border fa fa-lg fa-paperclip round_icon" /></a>
                      </td>
                      <td style={{ paddingRight: '10px' }}>
                        {(this.state.shared || this.state.imagen_preview) ? <button onClick={() => this.handleAddPublicacion()} className="btn-coment" data-dismiss="modal">Publicar</button> : ''}
                      </td>
                      <td>
                        <button className="btn-coment" data-dismiss="modal" type="button" onClick={this.hadleClick} style={{ background: '#dfdfdf', color: '#36414e' }}> Cerrar </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  }

  renderPublicaciones = () => {
    return (
      <Publicaciones
        publicaciones={this.state.publicaciones}
        publicaciones_ultimo_id={this.state.publicaciones_ultimo_id}
        ver_mas={this.state.ver_mas}
        handleVerMas={this.handleVerMas}
        handleAddLike={this.handleAddLike}
        handleRemoveLike={this.handleRemoveLike}
        handleAddComentario={this.handleAddComentario}
        user={this.props.user}
      />
    );
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        {/* {this.renderAgregarPublicacion()} */}
        <h4 className="iossala">Publicaciones</h4>
        {this.renderPublicaciones()}
      </div>
    );
  }
}

export default compose(
  translate('common'),
  withRouter
)(MarketplaceContainer);



// WEBPACK FOOTER //
// ./src/dashboard/mainPage/MarketplaceContainer.js